<div class="card border-0 shadow-sm mb-4 position-relative">
  <div class="page-disable-overlay bg-dark opacity-50 position-absolute w-100 h-100 top-0 start-0">
  </div>
  <div class="card-header bg-danger text-white">
    <h5 class="card-title mb-0">
      <i class="fa fa-tools me-2"></i>
      System Maintenance
    </h5>
  </div>
  <div class="card-body">
    <div class="row g-3">
      <div class="col-12">
        <h6 class="fw-semibold">Database Operations</h6>
        <div class="d-flex flex-wrap gap-2 mb-3">
          <button type="button" class="btn btn-outline-primary btn-sm">
            <i class="fa fa-database me-1"></i>
            Backup Database
          </button>
          <button type="button" class="btn btn-outline-info btn-sm">
            <i class="fa fa-broom me-1"></i>
            Clear Logs
          </button>
          <button type="button" class="btn btn-outline-secondary btn-sm">
            <i class="fa fa-chart-bar me-1"></i>
            Database Statistics
          </button>
        </div>
      </div>
      <div class="col-12">
        <h6 class="fw-semibold">Cache Management</h6>
        <div class="d-flex flex-wrap gap-2 mb-3">
          <button type="button" class="btn btn-outline-warning btn-sm">
            <i class="fa fa-trash me-1"></i>
            Clear Cache
          </button>
          <button type="button" class="btn btn-outline-success btn-sm">
            <i class="fa fa-sync me-1"></i>
            Refresh Cache
          </button>
        </div>
      </div>
      <div class="col-12">
        <h6 class="fw-semibold text-danger">Danger Zone</h6>
        <div class="border border-danger rounded p-3">
          <p class="text-danger mb-2">
            <i class="fa fa-exclamation-triangle me-1"></i>
            These actions cannot be undone. Proceed with caution.
          </p>
          <button type="button" class="btn btn-outline-danger btn-sm">
            <i class="fa fa-power-off me-1"></i>
            Restart Application
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
